// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1C0ZQ","question":"styles_question__l1jIM","inputVisibleButton":"styles_inputVisibleButton__13eJU","note":"styles_note__3HXbw"};